export const translations = {
  es: {
    nav: {
      features: "Funcionalidades",
      how: "Cómo Funciona",
      faq: "FAQ",
      demo: "Solicitar Demo",
      langLabel: "Idioma",
    },
    hero: {
      eyebrow: "Sistema POS en la nube · República Dominicana",
      title1: "El punto de venta que",
      title2: "tu restaurante necesita",
      subtitle:
        "Sistema completo en la nube para restaurantes, bares y cafés en República Dominicana. Facturación electrónica DGII, gestión de mesas, cobro y reportes — todo desde cualquier dispositivo.",
      ctaPrimary: "Solicitar Demo Gratis",
      ctaSecondary: "Ver funcionalidades",
      badges: ["Sin instalación", "Facturación DGII", "100% en la nube"],
    },
    lead: {
      eyebrow: "Agenda tu demo",
      title: "Recibe una demo personalizada — gratis",
      subtitle:
        "Déjanos tus datos y un especialista te contactará en menos de 24 horas. Sin compromiso.",
      fields: {
        name: "Tu nombre",
        business: "Nombre del negocio",
        phone: "WhatsApp / Teléfono",
        city: "Ciudad",
        email: "Tu correo (opcional)",
      },
      placeholders: {
        name: "Ej. Juan Pérez",
        business: "Ej. Restaurante La Esquina",
        phone: "Ej. 829-555-1234",
        city: "Ej. Santo Domingo",
        email: "tu@correo.com",
      },
      submit: "Quiero la demo",
      submitting: "Enviando...",
      orWhats: "O escríbenos directo por WhatsApp",
      success: {
        title: "¡Gracias! Te contactaremos pronto.",
        body: "Recibimos tus datos. Un especialista de VexlyPOS te escribirá en menos de 24 horas.",
        again: "Enviar otro",
      },
      errors: {
        required: "Este campo es obligatorio",
        minLen: "Demasiado corto",
        phoneInvalid: "Teléfono inválido",
        emailInvalid: "Correo inválido",
        network: "No pudimos enviar tu solicitud. Intenta de nuevo o escríbenos por WhatsApp.",
      },
      privacy: "Usaremos tus datos solo para contactarte sobre VexlyPOS.",
    },
    features: {
      eyebrow: "Funcionalidades",
      title: "Todo lo que tu negocio necesita, en un solo lugar",
      subtitle: "Diseñado para la realidad de los restaurantes dominicanos.",
      cards: [
        {
          title: "Facturación Electrónica DGII",
          body: "e-CF en tiempo real. Serie E completa (E31, E32, E34, E44, E45). QR fiscal en cada factura. 100% conforme con DGII.",
        },
        {
          title: "Gestión de Restaurante",
          body: "Mapa de mesas interactivo por áreas. Comandas automáticas a cocina y bar. Cuentas divididas. Mesa, Llevar, Delivery.",
        },
        {
          title: "Cobro Flexible",
          body: "Efectivo, tarjeta, transferencia, pagos mixtos, USD, EUR. Propina legal automática. Descuentos y promociones.",
        },
        {
          title: "Reportes en Tiempo Real",
          body: "Ventas por período y mesero. Cierre de caja automático. Anulaciones, propinas, productos más vendidos.",
        },
        {
          title: "Tu Negocio en Tus Manos",
          body: "Dashboard EN VIVO desde tu celular. Reportes de cierre y alertas de inventario a tu email. Autoriza cierres y anulaciones desde tu teléfono — sin estar en el local.",
        },
        {
          title: "Seguridad Total",
          body: "Login por PIN rápido. Roles y permisos personalizados por empleado. Auditoría completa de cada acción.",
        },
      ],
    },
    gallery: {
      eyebrow: "Capturas reales",
      title: "Hecho para verse bien en cualquier pantalla",
      subtitle: "Capturas reales del sistema. Mismo poder en desktop y móvil.",
      tabs: { desktop: "Desktop", mobile: "Móvil" },
      captions: {
        d1: "Dashboard — Modo Oscuro",
        d2: "Mapa de Mesas por Áreas",
        d3: "Toma de Órdenes por Categorías",
        d4: "Procesar Pago — Pagos Mixtos",
        d5: "Dashboard — Modo Claro",
        m1: "Login por PIN",
        m2: "Mapa de Mesas Móvil",
        m3: "Categorías Móvil",
        m4: "Procesar Pago Móvil",
        m5: "Dashboard Móvil",
      },
    },
    how: {
      eyebrow: "Cómo funciona",
      title: "Empieza en 3 pasos simples",
      steps: [
        {
          title: "Contáctanos",
          body: "Escríbenos por WhatsApp para agendar una demostración gratuita.",
        },
        {
          title: "Configuramos tu negocio",
          body: "En menos de 24 horas tu sistema está listo con tu menú, mesas, impuestos y empleados.",
        },
        {
          title: "¡Empieza a vender!",
          body: "Tu equipo empieza a usar VexlyPOS el mismo día. Capacitación incluida.",
        },
      ],
    },
    benefits: {
      eyebrow: "Beneficios",
      title: "Sin hardware costoso. Sin sorpresas.",
      items: [
        "Funciona en celular, tablet, laptop y PC",
        "Sin instalar nada — solo abre el navegador",
        "Usa los equipos que ya tienes",
        "Actualizaciones automáticas sin costo extra",
        "100% en la nube — tus datos siempre seguros",
        "Soporte técnico directo por WhatsApp",
        "Sin contratos largos",
        "Sin hardware costoso",
      ],
    },
    faq: {
      eyebrow: "FAQ",
      title: "Preguntas frecuentes",
      items: [
        {
          q: "¿Necesito comprar equipos especiales?",
          a: "No. VexlyPOS funciona en cualquier dispositivo con navegador web. Usa tu celular, tablet o computadora actual. Solo necesitas una impresora térmica para facturas.",
        },
        {
          q: "¿Cumple con los requisitos de DGII?",
          a: "Sí. VexlyPOS genera facturas electrónicas (e-CF) en tiempo real con QR fiscal. 100% conforme con la normativa de DGII.",
        },
        {
          q: "¿Funciona sin internet?",
          a: "Para facturar necesitas conexión. Pero puedes ver mesas, órdenes y pre-cuentas sin internet.",
        },
        {
          q: "¿Cuánto tiempo toma la instalación?",
          a: "Menos de 24 horas. Configuramos tu menú, mesas, impuestos y empleados. Tu equipo puede empezar el mismo día.",
        },
        {
          q: "¿Puedo ver mi negocio desde casa?",
          a: "Sí. El dashboard en tiempo real te permite monitorear ventas, mesas y anulaciones desde cualquier lugar. Recibes reportes por email.",
        },
        {
          q: "¿Tiene soporte técnico?",
          a: "Sí. Soporte directo por WhatsApp con respuesta rápida.",
        },
      ],
    },
    finalCta: {
      title: "¿Listo para modernizar tu negocio?",
      subtitle:
        "Agenda una demostración gratuita hoy y descubre cómo VexlyPOS puede transformar tu restaurante.",
      cta: "Solicitar Demo por WhatsApp",
    },
    footer: {
      tagline: "Sistema de punto de venta en la nube para restaurantes dominicanos.",
      rights: "© 2026 BRIGHTWAY SOLUTIONS LLC. Todos los derechos reservados.",
      legal: "VexlyPOS y Vexly One son productos de BRIGHTWAY SOLUTIONS LLC · New Brunswick, New Jersey, EE.UU.",
      madeIn: "Desarrollado en Estados Unidos 🇺🇸",
      sections: {
        product: "Producto",
        company: "Compañía",
        contact: "Contacto",
      },
      links: {
        features: "Funcionalidades",
        how: "Cómo Funciona",
        faq: "FAQ",
        contact: "Contacto",
      },
    },
  },
  en: {
    nav: {
      features: "Features",
      how: "How It Works",
      faq: "FAQ",
      demo: "Request Demo",
      langLabel: "Language",
    },
    hero: {
      eyebrow: "Cloud POS · Dominican Republic",
      title1: "The point of sale your",
      title2: "restaurant deserves",
      subtitle:
        "Complete cloud system for restaurants, bars and cafés in the Dominican Republic. DGII e-invoicing, table management, payments and reports — from any device.",
      ctaPrimary: "Get a Free Demo",
      ctaSecondary: "See features",
      badges: ["No install needed", "DGII e-invoicing", "100% cloud"],
    },
    lead: {
      eyebrow: "Book your demo",
      title: "Get a personalized demo — free",
      subtitle:
        "Leave your info and a specialist will contact you in less than 24 hours. No commitment.",
      fields: {
        name: "Your name",
        business: "Business name",
        phone: "WhatsApp / Phone",
        city: "City",
        email: "Your email (optional)",
      },
      placeholders: {
        name: "e.g. John Smith",
        business: "e.g. The Corner Restaurant",
        phone: "e.g. 829-555-1234",
        city: "e.g. Santo Domingo",
        email: "your@email.com",
      },
      submit: "I want the demo",
      submitting: "Sending...",
      orWhats: "Or message us directly on WhatsApp",
      success: {
        title: "Thanks! We'll be in touch shortly.",
        body: "We received your info. A VexlyPOS specialist will reach out in under 24 hours.",
        again: "Send another",
      },
      errors: {
        required: "This field is required",
        minLen: "Too short",
        phoneInvalid: "Invalid phone",
        emailInvalid: "Invalid email",
        network: "We couldn't send your request. Please try again or message us on WhatsApp.",
      },
      privacy: "We'll only use your data to contact you about VexlyPOS.",
    },
    features: {
      eyebrow: "Features",
      title: "Everything your business needs, in one place",
      subtitle: "Built for the reality of Dominican restaurants.",
      cards: [
        {
          title: "DGII e-Invoicing",
          body: "Real-time e-CF. Full Series E (E31, E32, E34, E44, E45). Fiscal QR on every invoice. 100% DGII compliant.",
        },
        {
          title: "Restaurant Operations",
          body: "Interactive table map by area. Automatic tickets to kitchen and bar. Split bills. Dine-in, Takeout, Delivery.",
        },
        {
          title: "Flexible Payments",
          body: "Cash, card, transfer, split payments, USD, EUR. Automatic legal tip. Discounts and promotions.",
        },
        {
          title: "Real-Time Reports",
          body: "Sales by period and server. Automatic cash close. Voids, tips, top-selling items.",
        },
        {
          title: "Your Business in Your Hands",
          body: "LIVE dashboard from your phone. Close-of-day reports and inventory alerts to your email. Approve closures and voids from your phone — no need to be on site.",
        },
        {
          title: "Full Security",
          body: "Fast PIN login. Custom roles and permissions per employee. Full audit trail of every action.",
        },
      ],
    },
    gallery: {
      eyebrow: "Real screens",
      title: "Built to look great on any screen",
      subtitle: "Real screenshots from the product. Same power on desktop and mobile.",
      tabs: { desktop: "Desktop", mobile: "Mobile" },
      captions: {
        d1: "Dashboard — Dark Mode",
        d2: "Table Map by Areas",
        d3: "Order Taking by Categories",
        d4: "Process Payment — Split Payments",
        d5: "Dashboard — Light Mode",
        m1: "PIN Login",
        m2: "Mobile Table Map",
        m3: "Mobile Categories",
        m4: "Mobile Payment",
        m5: "Mobile Dashboard",
      },
    },
    how: {
      eyebrow: "How it works",
      title: "Start in 3 simple steps",
      steps: [
        {
          title: "Contact us",
          body: "Reach out on WhatsApp to schedule a free demo.",
        },
        {
          title: "We set up your business",
          body: "In under 24 hours your system is ready with your menu, tables, taxes and employees.",
        },
        {
          title: "Start selling!",
          body: "Your team starts using VexlyPOS the same day. Training included.",
        },
      ],
    },
    benefits: {
      eyebrow: "Benefits",
      title: "No expensive hardware. No surprises.",
      items: [
        "Runs on phone, tablet, laptop and PC",
        "No install needed — just open the browser",
        "Use the devices you already have",
        "Free automatic updates",
        "100% cloud — your data is always safe",
        "Direct WhatsApp support",
        "No long-term contracts",
        "No expensive hardware",
      ],
    },
    faq: {
      eyebrow: "FAQ",
      title: "Frequently asked questions",
      items: [
        {
          q: "Do I need to buy special equipment?",
          a: "No. VexlyPOS works on any device with a web browser. Use your current phone, tablet or computer. You only need a thermal printer for receipts.",
        },
        {
          q: "Is it DGII compliant?",
          a: "Yes. VexlyPOS issues electronic invoices (e-CF) in real time with fiscal QR. 100% compliant with DGII regulations.",
        },
        {
          q: "Does it work offline?",
          a: "Invoicing requires internet. But you can view tables, orders and pre-bills offline.",
        },
        {
          q: "How long does setup take?",
          a: "Under 24 hours. We configure your menu, tables, taxes and employees. Your team can start the same day.",
        },
        {
          q: "Can I monitor my business from home?",
          a: "Yes. The real-time dashboard lets you monitor sales, tables and voids from anywhere. You also get email reports.",
        },
        {
          q: "Is there tech support?",
          a: "Yes. Direct WhatsApp support with fast response time.",
        },
      ],
    },
    finalCta: {
      title: "Ready to modernize your business?",
      subtitle:
        "Schedule a free demo today and discover how VexlyPOS can transform your restaurant.",
      cta: "Request Demo on WhatsApp",
    },
    footer: {
      tagline: "Cloud POS system for Dominican restaurants.",
      rights: "© 2026 BRIGHTWAY SOLUTIONS LLC. All rights reserved.",
      legal: "VexlyPOS and Vexly One are products of BRIGHTWAY SOLUTIONS LLC · New Brunswick, New Jersey, USA.",
      madeIn: "Developed in the USA 🇺🇸",
      sections: {
        product: "Product",
        company: "Company",
        contact: "Contact",
      },
      links: {
        features: "Features",
        how: "How It Works",
        faq: "FAQ",
        contact: "Contact",
      },
    },
  },
};

export const WHATSAPP_URL =
  "https://wa.me/18296708797?text=Hola%20quiero%20una%20demo%20de%20VexlyPOS";
export const WHATSAPP_NUMBER = "829-670-8797";
export const INSTAGRAM = "@vexlypos";
export const INSTAGRAM_URL = "https://instagram.com/vexlypos";
